module.exports = __webpack_public_path__ + "static/media/map_pin_location.559f71d5.svg";